function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'bleu': 'rgb(33, 56, 161)','bleu-boite-de-4': 'rgb(33, 56, 161)','bleu-boite-de-6': 'rgb(33, 56, 161)','bleu-boite-de-24': 'rgb(33, 56, 161)','noir': 'rgb(0, 0, 0)','noir-boite-de-4': 'rgb(0, 0, 0)','noir-boite-de-6': 'rgb(0, 0, 0)','noir-boite-de-24': 'rgb(0, 0, 0)','brun': 'rgb(109, 65, 42)','brun-boite-de-4': 'rgb(109, 65, 42)','brun-boite-de-6': 'rgb(109, 65, 42)','brun-boite-de-24': 'rgb(109, 65, 42)','vert-pomme': 'rgb(93, 113, 25)','vert': 'rgb(50, 98, 14)','vert-fonce': 'rgb(49, 69, 40)','vert-boite-de-4': 'rgb(49, 69, 40)','vert-boite-de-6': 'rgb(49, 69, 40)','vert-boite-de-24': 'rgb(49, 69, 40)','jaune': 'rgb(255, 222, 50)','jaune-boite-de-4': 'rgb(255, 222, 50)','jaune-boite-de-6': 'rgb(255, 222, 50)','jaune-boite-de-24': 'rgb(255, 222, 50)','rouge': 'rgb(206, 0, 0)','rouge-boite-de-4': 'rgb(206, 0, 0)','rouge-boite-de-6': 'rgb(206, 0, 0)','rouge-boite-de-24': 'rgb(206, 0, 0)','gris': 'rgb(177, 172, 168)','gris-boite-de-4': 'rgb(177, 172, 168)','gris-boite-de-6': 'rgb(177, 172, 168)','gris-boite-de-24': 'rgb(177, 172, 168)','charcoal': 'rgb(85, 78, 75)','blanc': 'rgb(255, 255, 255)','orange': 'rgb(218, 98, 32)','orange-boite-de-4': 'rgb(218, 98, 32)','orange-boite-de-6': 'rgb(218, 98, 32)','orange-boite-de-24': 'rgb(218, 98, 32)','stainless': 'rgb(177, 172, 168)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
